exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-dropzone {\n    border: 2px dashed #e5e5e5;\n}\n.tree-selected {\n    background: #d5fbff !important;\n}\n.breadcrumb-item:hover, #add-file-button:hover {\n    cursor: pointer;\n}\n.search-highlight {\n    background: #fff700;\n}\n", ""]);

// exports
